function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineDocument } from 'sanity-typed-queries';
import { TaxonomyType } from '@stereoagency/constants';
import { arrayEntry, internationalizedArrayDepartments, internationalizedArrayPageSections, internationalizedArraySimpleBlockContent, internationalizedArrayString, sanityReference, documentSlug } from '../fragments/index.js';
import { columnInfoGroup, department, mediaSection, simpleDatalistSection } from '../objects/index.js';
import profile from './profile.js';
import taxonomy from './taxonomy.js';
var schema = defineDocument('researchPlatform', {
    slug: _object_spread({
        title: 'Slug'
    }, documentSlug.factory()),
    title: {
        title: 'Title',
        type: 'internationalizedArrayString'
    },
    introduction: {
        title: 'Introduction',
        type: 'internationalizedArraySimpleBlockContent'
    },
    researchPlatformLeader: {
        title: 'Leader',
        type: 'reference',
        to: [
            {
                type: 'profile'
            }
        ]
    },
    departments: {
        title: 'Staff',
        type: 'internationalizedArrayDepartments'
    },
    aboutContent: {
        title: 'About Content',
        type: 'internationalizedArrayPageSections'
    },
    researchContent: {
        title: 'Research Content',
        type: 'internationalizedArrayPageSections'
    },
    bioContent: {
        title: 'Bio Content',
        type: 'internationalizedArrayPageSections'
    },
    teamContent: {
        title: 'Team Content',
        type: 'internationalizedArrayPageSections'
    },
    taxonomies: {
        title: 'Taxonomies',
        type: 'array',
        description: 'Only disease areas supported',
        of: [
            {
                type: 'reference',
                to: [
                    {
                        type: 'taxonomy'
                    }
                ],
                options: {
                    filter: 'type in $types',
                    filterParams: {
                        types: [
                            TaxonomyType.DISEASE_AREA
                        ]
                    }
                }
            }
        ]
    }
}, [
    mediaSection.schema.mediaSection,
    columnInfoGroup.schema.columnInfoGroup,
    simpleDatalistSection.schema.simpleDatalistSection,
    taxonomy.schema.taxonomy,
    profile.schema.profile,
    department.schema.department,
    {},
    {},
    {},
    {}
]);
var validator = z.object({
    slug: documentSlug.validator,
    title: internationalizedArrayString.validator,
    introduction: internationalizedArraySimpleBlockContent.validator,
    researchPlatformLeader: sanityReference.validator,
    departments: internationalizedArrayDepartments.validator,
    aboutContent: internationalizedArrayPageSections.validator,
    researchContent: internationalizedArrayPageSections.validator,
    bioContent: internationalizedArrayPageSections.validator,
    teamContent: internationalizedArrayPageSections.validator,
    taxonomies: z.array(sanityReference.validator.merge(arrayEntry.validator))
}).partial();
schema.researchPlatform;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=researchPlatform.js.map